import { FormHelperText } from '@mui/material';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { DateTime } from 'luxon';

import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import type { ReservationFormInput } from '../schema/reservationForm.schema';

export function PickupDateMismatchMessage({ index }: { index: number }) {
  const t = useCommonTranslation();
  const { control } = useFormContext<ReservationFormInput>();

  const appointmentDateTime = useWatch({
    control,
    name: `trips.${index}.appointmentDateTime`,
  }) as DateTime | null | undefined;
  const pickupDateTime = useWatch({
    control,
    name: `trips.${index}.pickupDateTime`,
  }) as DateTime | null | undefined;
  // The field itself already shows this same text as its own (blocking)
  // error when pickup is out of range — avoid rendering it a second time.
  const { errors } = useFormState({
    control,
    name: `trips.${index}.pickupDateTime`,
  });
  const hasFieldError = Boolean(errors.trips?.[index]?.pickupDateTime);

  if (!appointmentDateTime?.isValid || !pickupDateTime?.isValid) return null;
  if (pickupDateTime.hasSame(appointmentDateTime, 'day')) return null;
  if (hasFieldError) return null;

  return (
    <FormHelperText
      sx={{ color: 'warning.main' }}
      data-testid="pickup-date-error">
      {t('reservation.pickupDateDifferentThanAppointmentWarning')}
    </FormHelperText>
  );
}
